import { NextSeo } from 'next-seo';

import placeholder from 'lib/placeholder';

const CouponsHead = () => (
  <NextSeo
    description={placeholder('seo.coupons.description')}
    openGraph={{
      title: placeholder('seo.coupons.title'),
      description: placeholder('seo.coupons.description'),
    }}
    title={placeholder('seo.coupons.title')}
  />
);

export default CouponsHead;
